
import Util from 'service/util';
import EInvoicingAuditTable from './EInvoicingAuditTable';

export const EInvoicingAuditBatchCard = ({ batch, filter, onClose }) =>
{
  return (<>
    <div className="box">
      <h3 className="box-head">寄送紀錄細明</h3>
      <div className="box-body">
        <label className="field">
          <strong>批次編號</strong>
          <span>{ batch.batch_id }</span>
        </label>
        <label className="field">
          <strong>寄出時間</strong>
          <span>{ Util.LongDate(batch.sent_dtm) }</span>
        </label>
        <label className="field">
          <strong>操作人</strong>
          <span>{ batch.sent_by }</span>
        </label>
        <label className="field">
          <strong>成功/失敗</strong>
          <span>{ batch.succeed?.length || 0 } / { batch.failed?.length || 0 }</span>
        </label>
        <div>
          <button className="btn white" onClick={onClose}>返回</button>
        </div>
      </div>
    </div>
    <EInvoicingAuditTable batch={batch} filter={filter} />
  </>);
}

export default EInvoicingAuditBatchCard;
